/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-undef */
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { getTableContainerHeight } from "../../../Utils/getTableContainerHeight";
import ChevronIcon from "../../../Common/Svgs/ChevronIcon";
import RequestIcon from "../../../Common/Svgs/RequestIcon";
import CustomTable from "../../../Core/Components/CustomTable";
import { rentalRequestColumns } from "./data";

const LOCAL_DEFAULT_LIMIT = 10;

const RentalList = ({ currentPage, setCurrentPage }) => {
  const { requestRentalList } = useSelector((state) => state.rentals);

  const tableContainerRef = useRef(null);

  return (
    <div>
      <div
        className={`h-[calc(100vh-72px-71px-69px)] ${
          requestRentalList?.result?.length && "overflow-y-scroll"
        }`}
        ref={tableContainerRef}
      >
        <CustomTable
          disableScroll
          columns={rentalRequestColumns}
          data={requestRentalList?.result || []}
          emptyState={<RequestIcon size={16} className="text-dark-grey-text" />}
          emptyStateHeight={getTableContainerHeight(tableContainerRef)}
          rowClassName="group"
          pagination={{
            pageSize: LOCAL_DEFAULT_LIMIT,
            total: requestRentalList?.totalRecords || 10,
            showSizeChanger: false,
            onChange: (page) => {
              setCurrentPage(page);
            },
            current: currentPage,
            itemRender: (current, type, originalElement) => {
              const lastPage = requestRentalList.totalRecords ?? 10 / current;

              if (type === "prev" && current === 0) {
                return (
                  <button
                    type="button"
                    className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                    style={{
                      pointerEvents: "none",
                    }}
                  >
                    <ChevronIcon className="stroke-dark-gray" />
                  </button>
                );
              }

              if (type === "prev" && current > 0) {
                return (
                  <button
                    type="button"
                    className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                  >
                    <ChevronIcon className="stroke-dark-gray" />
                  </button>
                );
              }

              if (type === "next" && lastPage <= 10) {
                return (
                  <button
                    type="button"
                    className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                    style={{ pointerEvents: "none" }}
                  >
                    <ChevronIcon className="stroke-dark-gray" />
                  </button>
                );
              }

              if (type === "next") {
                return (
                  <button
                    type="button"
                    className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                  >
                    <ChevronIcon className="stroke-dark-gray" />
                  </button>
                );
              }

              return originalElement;
            },
          }}
        />
      </div>
    </div>
  );
};

export default RentalList;
